// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2wz9Y","filesListContainer":"PosDisputesFiles_filesListContainer__3YLuw","filesButton":"PosDisputesFiles_filesButton__72WrQ"};